module.exports = __webpack_public_path__ + "img/love.153de569.gif";